define([
	"csi/action",
	"csi/canvas/storeFactory",
	"csi/config/preferences",
	"csi/locale",
	"csi/page/ComparePageStore",
	"csi/registry/bannerRegistry",
	"csi/registry/pageStoreRegistry",
	"csi/utility/stringUtility",
	"csi/xml",
	"Specification/BOM/BOMCompareBanner",
], function (csiAction, storeFactory, configPreferences, locale, ComparePageStore,
	{ registerBanner }, { registerPageStore }, { trimmedString }, xml, BOMCompareBanner) {

	const MATERIAL_BOM = "MaterialBOM";
	const MATERIAL_BOM_REVISION = "MaterialBOMRevision";
	const MATERIAL_COLOR_DATAHEET_REVISION = "ColorDataSheetRevision";
	const MATERIAL_DATAHEET_REVISION = "MaterialDataSheetRevision";
	const MATERIAL_SAMPLE = "MaterialSample";
	const COLOR_MATERIAL = "ColorMaterial";
	const PART_MATERIAL = "PartMaterial";
	const THEME = "Theme";
	const THEME_PLACEMENT = "MaterialPlanPlacement";

	storeFactory.add(MATERIAL_BOM_REVISION, COLOR_MATERIAL, "Child:BOMProductColors");
	storeFactory.add(MATERIAL_BOM_REVISION, PART_MATERIAL, "Child:Items");
	storeFactory.add(THEME, THEME_PLACEMENT, "Child:Items");

	storeFactory.add(MATERIAL_DATAHEET_REVISION, COLOR_MATERIAL, null, function (node, cache) {
		const dataSheet = cache.get(node.__Parent__);

		// if there are referenced ColorDataSheets, then return ColorMaterial from only those data sheets
		if (dataSheet.DataSheets.length > 0) {
			return xml.path(xml.ATTR_PARENT, "DataSheets", xml.ATTR_PARENT);
		}

		// otherwise, return all ColorMaterial from the Material
		return xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT, "ProductColors");
	});

	storeFactory.add(MATERIAL_DATAHEET_REVISION, MATERIAL_SAMPLE, null, function (node, cache) {
		const dataSheet = cache.get(node.__Parent__);

		// if there are referenced Samples from the data sheet, then return only those
		if (dataSheet.DataSheetSamples.length > 0) {
			return xml.path(xml.ATTR_PARENT, "DataSheetSamples");
		}

		// otherwise, return all samples from the Material
		return xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT, "ProductSourcing", "ProductSources", "Samples");
	});

	storeFactory.add(MATERIAL_COLOR_DATAHEET_REVISION, MATERIAL_SAMPLE, null, function (node, cache) {
		const dataSheet = cache.get(node.__Parent__);

		// if there are referenced Samples from the data sheet, then return only those
		if (dataSheet.DataSheetSamples.length > 0) {
			return xml.path(xml.ATTR_PARENT, "DataSheetSamples");
		}

		// otherwise, return all samples from the Material
		return xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT, xml.ATTR_PARENT, "ProductSourcing", "ProductSources", "Samples");
	});

	// register BOM-specific controllers for state actions
	csiAction.registerControllers("MaterialBOM", {
		"MakePending": "Specification/BOM/PhaseFreezeController",
		"EndPhase": "Specification/BOM/PhaseFreezeController",
		"StartApprovalWorkflow": "Specification/BOM/PhaseFreezeStartApprovalWorkflowController"
	});

	/* --- BOM Compare --- */
	/** initialize the banner for BOM Compare  */
	registerBanner(MATERIAL_BOM, BOMCompareBanner.default);

	/** initialize the page store for BOM Compare  */
	const _initCompareStore = async (node, revisionNode, cache) => {
		return new ComparePageStore.default(node, revisionNode, cache);
	}

	// register the page store for PP node
	registerPageStore(MATERIAL_BOM, _initCompareStore);

	return {
		onActionNewColorDataSheet: function (ac) {
			var name = trimmedString(ac.m_formData.getFieldValue(xml.ATTR_NAME));
			if (!name) {
				var subtype = ac.m_formData.getFieldValue("SubType");
				ac.m_cnNew.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, locale.getEnumName(subtype));
			}

			var urlColor = ac.m_formData.getFieldValue("Color");
			if (xml.isValidURL(urlColor)) {
				ac.m_writer.changeNode(urlColor).changeAttribute("DataSheets", xml.ATTR_REFLIST, [ac.m_urlNode], true);
			}
		}
	};
});
